require("prism-themes/themes/prism-synthwave84.css")